import React from 'react';
import { Loader2 } from 'lucide-react';
import styles from './BuilderIconButton.module.scss';

interface BuilderIconButtonProps {
  icon: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  danger?: boolean;
  disabled?: boolean;
  loading?: boolean;
  title?: string;
}

/**
 * Circular icon button matching the reference design's `.btn-icon`.
 * Forwards its ref so it can serve as the trigger child of AntD overlay
 * components (Tooltip/Popconfirm), which warn when their child is a plain
 * function component that can't hold a ref.
 */
export const BuilderIconButton = React.forwardRef<HTMLButtonElement, BuilderIconButtonProps>(
  ({ icon, onClick, danger, disabled, loading, title, ...rest }, ref) => (
    <button
      ref={ref}
      type="button"
      className={`${styles.btnIcon} ${danger ? styles.danger : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
      aria-label={title}
      {...rest}
    >
      {loading ? <Loader2 className="animate-spin" style={{ width: '1em', height: '1em' }} /> : icon}
    </button>
  )
);

BuilderIconButton.displayName = 'BuilderIconButton';

export default BuilderIconButton;
